// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cu-page {
  --cu-type-heading: clamp(2.1rem, 2.8vw, 2.8rem);
  --cu-type-subheading: 1.5rem;
  --cu-type-card-heading: 1.2rem;
  --cu-type-body: 1.05rem;
  --cu-type-label: 0.92rem;
  --cu-type-cta: 1.02rem;
  background: #ece4ed;
  min-height: 100vh;
  padding: 2.5rem 0 4rem;
  color: #370b3b;
}

.cu-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.cu-hero {
  text-align: center;
  padding-bottom: 2rem;
}

.cu-hero__title {
  font-size: var(--cu-type-heading);
  font-weight: 800;
  margin-bottom: 0.5rem;
  font-family: "Lexend", system-ui, sans-serif;
  color:#370b3b;
}

.cu-hero__subtitle {
  margin: 0 auto;
  max-width: 640px;
  line-height: 1.6;
  color: #4a4f65;
  font-size: var(--cu-type-body);
}

.cu-quick {
  margin: 2rem 0 3rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.cu-socialLinks {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: -1.75rem 0 2rem;
}

.cu-socialLink {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.9rem;
  border-radius: 999px;
  border: 1px solid #370b3b;
  background: #d6c3d9;
  color: #370b3b;
  text-decoration: none;
  font-weight: 700;
  font-size: var(--cu-type-label);
}

.cu-socialLink:hover {
  background: #f59e0b;
  border-color: #f59e0b;
  color: #1f2937;
  text-decoration: none;
}

.cu-quickCard {
  background: #d6c3d9;
  border-radius: 14px;
  padding: 1rem 1.15rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #370b3b;
  text-decoration: none;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.06);
  border: 1px solid #370b3b

}

.cu-quickIcon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #e0f2fe;
  display: grid;
  place-items: center;
  font-size: 1.35rem;
  color: #370b3b;
}

.cu-quickIcon--green {
  background: #ebf7f0;
  color: #0f9d58;
}

.cu-quickText {
  display: flex;
  flex-direction: column;
}

.cu-quickSmall {
  font-size: 0.85rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #637094;
}

.cu-quickBold {
  font-weight: 700;
  font-size: 1.08rem;
}

.cu-quickBold--green {
  color: #0f9d58;
}

.cu-main {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 2rem;
}

.cu-formCard,
.cu-right {
  background: #ffffff;
  border-radius: 18px;
  padding: 2rem;
  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.08);
}

.cu-formHead {
  margin-bottom: 1.5rem;
}

.cu-formTitle {
  margin: 0;
  font-size: var(--cu-type-subheading);
  font-weight: 800;
}

.cu-formSub {
  margin: 0.4rem 0 0;
  color: #56617e;
  font-size: var(--cu-type-body);
}

.cu-formFallback {
  margin: 0.5rem 0 0;
  color: #b91c1c;
  font-size: 1rem;
  font-weight: 700;
}

.cu-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cu-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.cu-label {
  font-size: var(--cu-type-label);
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #637094;
}

.cu-input,
.cu-textarea {
  border: 1px solid #dfe5f3;
  border-radius: 12px;
  padding: 0.85rem 1rem;
  font-size: var(--cu-type-body);
  font-family: inherit;
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.cu-input:focus,
.cu-textarea:focus {
  outline: none;
  border-color: #0f49bd;
  transform: translateY(-1px);
}

.cu-textarea {
  min-height: 160px;
  resize: vertical;
}

.cu-row2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.cu-btnPrimary {
  background: #370b3b;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 0.85rem 1.3rem;
  font-weight: 700;
  font-size: var(--cu-type-cta);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.cu-btnPrimary--link {
  text-decoration: none;
  width: fit-content;
  margin-top: 0.7rem;
}

.cu-btnPrimary:hover {
  transform: translateY(-2px);
  color: #f59e0b;
  box-shadow: 0 15px 25px rgba(15, 73, 189, 0.35);
}

.cu-btnPrimary:disabled {
  cursor: not-allowed;
  opacity: 0.7;
  transform: none;
  box-shadow: none;
}

.cu-sendIcon {
  font-size: 1rem;
}

.cu-submitMsg {
  margin: 0;
  font-weight: 600;
}

.cu-submitMsg--success {
  color: #15803d;
}

.cu-submitMsg--error {
  color: #b91c1c;
}

.cu-right {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.cu-map {
  border-radius: 18px;
  box-shadow: 0 25px 40px rgba(15, 23, 42, 0.15);
  overflow: hidden;
  padding: 0;
  background: #fefefe;
  border: 1px solid rgba(15, 23, 42, 0.05);
}

.cu-map iframe {
  width: 100%;
  border: none;
  min-height: 220px;
  display: block;
}

.cu-mapBtn {
  background: #370b3b;
  color: white;
  border: none;
  border-radius: 999px;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  cursor: pointer;
  margin: 1rem 1.5rem;
  align-self: flex-start;
  transition: background 0.2s ease;
}

.cu-mapBtn:hover {
  background: #0d3c94;
}

.cu-centers {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.cu-centersTitle {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-weight: 700;
  font-size: var(--cu-type-card-heading);
}

.cu-centerCard {
  border-radius: 18px;
  padding: 1.3rem;
  border: 1px solid #e4e7ef;
  background: #fdfdfd;
  box-shadow: 0 15px 30px rgba(15, 23, 42, 0.06);
}

.cu-centerCard--primary {
  border-color: rgba(31, 102, 255, 0.35);
}

.cu-centerCard--accent {
  border-color: rgba(244, 143, 177, 0.4);
}

.cu-centerTop {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.9rem;
}

.cu-centerName {
  font-weight: 800;
  font-size: 1.08rem;
}

.cu-tag {
  padding: 0.25rem 0.65rem;
  border-radius: 999px;
  font-size: 0.85rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
}

.cu-tag--primary {
  background: rgba(31, 102, 255, 0.12);
  color: #0f49bd;
}

.cu-tag--accent {
  background: rgba(244, 143, 177, 0.18);
  color: #cb1f72;
}

.cu-infoRow {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.4rem;
  color: #616a85;
  font-size: var(--cu-type-body);
}

.cu-infoRow span:first-child {
  color: #0f49bd;
}

.cu-cta {
  margin-top: 3rem;
  position: relative;
  background: #370b3b;
  border-radius: 28px;
  padding: 3rem 1rem 2rem;
  overflow: hidden;
  color: #fff;
  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.35);
}

.cu-ctaGlow {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  opacity: 0.25;
}

.cu-ctaGlow--left {
  background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.5), transparent 55%);
}

.cu-ctaGlow--right {
  background: radial-gradient(circle at 75% 30%, rgba(255, 255, 255, 0.35), transparent 60%);
}

.cu-ctaInner {
  position: relative;
  max-width: 960px;
  margin: 0 auto;
}

.cu-ctaInner h2 {
  margin: 0;
  font-size: clamp(2rem, 3vw, 2.6rem);
  font-weight: 900;
  color: #ffffff;
}

.cu-ctaInner p {
  margin: 0.75rem 0 1.5rem;
  max-width: 600px;
  line-height: 1.6;
  color: #ffffff;
}

.cu-ctaActions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.cu-ctaPrimary,
.cu-ctaGhost {
  border-radius: 999px;
  padding: 0.9rem 1.8rem;
  font-weight: 700;
  font-size: var(--cu-type-cta);
  cursor: pointer;
  border: none;
  transition: transform 0.2s ease;
}

.cu-ctaPrimary {
  background: #fff;
  color: #370b3b;
}

.cu-ctaGhost {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.55);
  color: #fff;
  text-decoration: none;
}

.cu-ctaPrimary:hover,
.cu-ctaGhost:hover {
  transform: translateY(-2px);
  color: #f59e0b;
}

@media (max-width: 1024px) {
  .cu-main {
    grid-template-columns: 1fr;
  }
  .cu-row2 {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .cu-spotlight,
  .cu-ctaInner {
    padding: 0 1rem;
  }
}

html[data-theme="dark"] .cu-page {
  background: #02030a;
  color: #f8fafc;
}

html[data-theme="dark"] .cu-hero__subtitle,
html[data-theme="dark"] .cu-formSub,
html[data-theme="dark"] .cu-centerInfo,
html[data-theme="dark"] .cu-ctaInner p {
  color: rgba(248, 250, 252, 0.72);
}

html[data-theme="dark"] .cu-quickCard,
html[data-theme="dark"] .cu-formCard,
html[data-theme="dark"] .cu-right,
html[data-theme="dark"] .cu-map,
html[data-theme="dark"] .cu-centerCard,
html[data-theme="dark"] .cu-cta {
  background: #0b1220;
  border-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.55);
}

html[data-theme="dark"] .cu-mapOverlay,
html[data-theme="dark"] .cu-ctaGlow {
  background: rgba(255, 255, 255, 0.05);
}

html[data-theme="dark"] .cu-quickIcon {
  background: rgba(255, 255, 255, 0.08);
  color: #f8fafc;
}

html[data-theme="dark"] .cu-quickIcon--green {
  background: rgba(22, 163, 74, 0.2);
}

html[data-theme="dark"] .cu-input,
html[data-theme="dark"] .cu-textarea {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  color: #fff;
}

html[data-theme="dark"] .cu-mapBtn {
  background: #1f66ff;
  color: #fff;
}

html[data-theme="dark"] .cu-ctaPrimary {
  background: #fff;
  color: #0b1220;
}

html[data-theme="dark"] .cu-ctaGhost {
  border-color: rgba(255, 255, 255, 0.24);
}

html[data-theme="dark"] .cu-hero {
  color: #f8fafc;
}

html[data-theme="dark"] .cu-quickSmall,
html[data-theme="dark"] .cu-quickBold,
html[data-theme="dark"] .cu-centerName,
html[data-theme="dark"] .cu-tag {
  color: #f1f5ff;
}

html[data-theme="dark"] .cu-mapBg {
  filter: none;
  opacity: 0.7;
}

html[data-theme="dark"] .cu-page::before {
  content: "";
  position: fixed;
  inset: 0;
  background: #02030a;
  z-index: -1;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Contact/contact-us.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,8CAA8C;EAC9C;;AAEF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;EACpB,uDAAuD;AACzD;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yFAAyF;AAC3F;;AAEA;EACE,0FAA0F;AAC5F;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;;;;EAME,mBAAmB;EACnB,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,qCAAqC;EACrC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".cu-page {\r\n  --cu-type-heading: clamp(2.1rem, 2.8vw, 2.8rem);\r\n  --cu-type-subheading: 1.5rem;\r\n  --cu-type-card-heading: 1.2rem;\r\n  --cu-type-body: 1.05rem;\r\n  --cu-type-label: 0.92rem;\r\n  --cu-type-cta: 1.02rem;\r\n  background: #ece4ed;\r\n  min-height: 100vh;\r\n  padding: 2.5rem 0 4rem;\r\n  color: #370b3b;\r\n}\r\n\r\n.cu-container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 0 1.5rem;\r\n}\r\n\r\n.cu-hero {\r\n  text-align: center;\r\n  padding-bottom: 2rem;\r\n}\r\n\r\n.cu-hero__title {\r\n  font-size: var(--cu-type-heading);\r\n  font-weight: 800;\r\n  margin-bottom: 0.5rem;\r\n  font-family: \"Lexend\", system-ui, sans-serif;\r\n  color:#370b3b;\r\n}\r\n\r\n.cu-hero__subtitle {\r\n  margin: 0 auto;\r\n  max-width: 640px;\r\n  line-height: 1.6;\r\n  color: #4a4f65;\r\n  font-size: var(--cu-type-body);\r\n}\r\n\r\n.cu-quick {\r\n  margin: 2rem 0 3rem;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.cu-socialLinks {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n  margin: -1.75rem 0 2rem;\r\n}\r\n\r\n.cu-socialLink {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0.5rem 0.9rem;\r\n  border-radius: 999px;\r\n  border: 1px solid #370b3b;\r\n  background: #d6c3d9;\r\n  color: #370b3b;\r\n  text-decoration: none;\r\n  font-weight: 700;\r\n  font-size: var(--cu-type-label);\r\n}\r\n\r\n.cu-socialLink:hover {\r\n  background: #f59e0b;\r\n  border-color: #f59e0b;\r\n  color: #1f2937;\r\n  text-decoration: none;\r\n}\r\n\r\n.cu-quickCard {\r\n  background: #d6c3d9;\r\n  border-radius: 14px;\r\n  padding: 1rem 1.15rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  color: #370b3b;\r\n  text-decoration: none;\r\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.06);\r\n  border: 1px solid #370b3b\r\n\r\n}\r\n\r\n.cu-quickIcon {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 12px;\r\n  background: #e0f2fe;\r\n  display: grid;\r\n  place-items: center;\r\n  font-size: 1.35rem;\r\n  color: #370b3b;\r\n}\r\n\r\n.cu-quickIcon--green {\r\n  background: #ebf7f0;\r\n  color: #0f9d58;\r\n}\r\n\r\n.cu-quickText {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.cu-quickSmall {\r\n  font-size: 0.85rem;\r\n  letter-spacing: 0.18em;\r\n  text-transform: uppercase;\r\n  color: #637094;\r\n}\r\n\r\n.cu-quickBold {\r\n  font-weight: 700;\r\n  font-size: 1.08rem;\r\n}\r\n\r\n.cu-quickBold--green {\r\n  color: #0f9d58;\r\n}\r\n\r\n.cu-main {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\r\n  gap: 2rem;\r\n}\r\n\r\n.cu-formCard,\r\n.cu-right {\r\n  background: #ffffff;\r\n  border-radius: 18px;\r\n  padding: 2rem;\r\n  box-shadow: 0 25px 50px rgba(15, 23, 42, 0.08);\r\n}\r\n\r\n.cu-formHead {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.cu-formTitle {\r\n  margin: 0;\r\n  font-size: var(--cu-type-subheading);\r\n  font-weight: 800;\r\n}\r\n\r\n.cu-formSub {\r\n  margin: 0.4rem 0 0;\r\n  color: #56617e;\r\n  font-size: var(--cu-type-body);\r\n}\r\n\r\n.cu-formFallback {\r\n  margin: 0.5rem 0 0;\r\n  color: #b91c1c;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.cu-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.cu-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.cu-label {\r\n  font-size: var(--cu-type-label);\r\n  letter-spacing: 0.2em;\r\n  text-transform: uppercase;\r\n  color: #637094;\r\n}\r\n\r\n.cu-input,\r\n.cu-textarea {\r\n  border: 1px solid #dfe5f3;\r\n  border-radius: 12px;\r\n  padding: 0.85rem 1rem;\r\n  font-size: var(--cu-type-body);\r\n  font-family: inherit;\r\n  transition: border-color 0.2s ease, transform 0.2s ease;\r\n}\r\n\r\n.cu-input:focus,\r\n.cu-textarea:focus {\r\n  outline: none;\r\n  border-color: #0f49bd;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.cu-textarea {\r\n  min-height: 160px;\r\n  resize: vertical;\r\n}\r\n\r\n.cu-row2 {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.cu-btnPrimary {\r\n  background: #370b3b;\r\n  color: #ffffff;\r\n  border: none;\r\n  border-radius: 12px;\r\n  padding: 0.85rem 1.3rem;\r\n  font-weight: 700;\r\n  font-size: var(--cu-type-cta);\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  justify-content: center;\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.cu-btnPrimary--link {\r\n  text-decoration: none;\r\n  width: fit-content;\r\n  margin-top: 0.7rem;\r\n}\r\n\r\n.cu-btnPrimary:hover {\r\n  transform: translateY(-2px);\r\n  color: #f59e0b;\r\n  box-shadow: 0 15px 25px rgba(15, 73, 189, 0.35);\r\n}\r\n\r\n.cu-btnPrimary:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n  transform: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.cu-sendIcon {\r\n  font-size: 1rem;\r\n}\r\n\r\n.cu-submitMsg {\r\n  margin: 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.cu-submitMsg--success {\r\n  color: #15803d;\r\n}\r\n\r\n.cu-submitMsg--error {\r\n  color: #b91c1c;\r\n}\r\n\r\n.cu-right {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.cu-map {\r\n  border-radius: 18px;\r\n  box-shadow: 0 25px 40px rgba(15, 23, 42, 0.15);\r\n  overflow: hidden;\r\n  padding: 0;\r\n  background: #fefefe;\r\n  border: 1px solid rgba(15, 23, 42, 0.05);\r\n}\r\n\r\n.cu-map iframe {\r\n  width: 100%;\r\n  border: none;\r\n  min-height: 220px;\r\n  display: block;\r\n}\r\n\r\n.cu-mapBtn {\r\n  background: #370b3b;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 999px;\r\n  padding: 0.75rem 1.5rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  margin: 1rem 1.5rem;\r\n  align-self: flex-start;\r\n  transition: background 0.2s ease;\r\n}\r\n\r\n.cu-mapBtn:hover {\r\n  background: #0d3c94;\r\n}\r\n\r\n.cu-centers {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem;\r\n}\r\n\r\n.cu-centersTitle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  font-weight: 700;\r\n  font-size: var(--cu-type-card-heading);\r\n}\r\n\r\n.cu-centerCard {\r\n  border-radius: 18px;\r\n  padding: 1.3rem;\r\n  border: 1px solid #e4e7ef;\r\n  background: #fdfdfd;\r\n  box-shadow: 0 15px 30px rgba(15, 23, 42, 0.06);\r\n}\r\n\r\n.cu-centerCard--primary {\r\n  border-color: rgba(31, 102, 255, 0.35);\r\n}\r\n\r\n.cu-centerCard--accent {\r\n  border-color: rgba(244, 143, 177, 0.4);\r\n}\r\n\r\n.cu-centerTop {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 0.9rem;\r\n}\r\n\r\n.cu-centerName {\r\n  font-weight: 800;\r\n  font-size: 1.08rem;\r\n}\r\n\r\n.cu-tag {\r\n  padding: 0.25rem 0.65rem;\r\n  border-radius: 999px;\r\n  font-size: 0.85rem;\r\n  letter-spacing: 0.15em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.cu-tag--primary {\r\n  background: rgba(31, 102, 255, 0.12);\r\n  color: #0f49bd;\r\n}\r\n\r\n.cu-tag--accent {\r\n  background: rgba(244, 143, 177, 0.18);\r\n  color: #cb1f72;\r\n}\r\n\r\n.cu-infoRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  margin-bottom: 0.4rem;\r\n  color: #616a85;\r\n  font-size: var(--cu-type-body);\r\n}\r\n\r\n.cu-infoRow span:first-child {\r\n  color: #0f49bd;\r\n}\r\n\r\n.cu-cta {\r\n  margin-top: 3rem;\r\n  position: relative;\r\n  background: #370b3b;\r\n  border-radius: 28px;\r\n  padding: 3rem 1rem 2rem;\r\n  overflow: hidden;\r\n  color: #fff;\r\n  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.35);\r\n}\r\n\r\n.cu-ctaGlow {\r\n  position: absolute;\r\n  inset: 0;\r\n  border-radius: inherit;\r\n  opacity: 0.25;\r\n}\r\n\r\n.cu-ctaGlow--left {\r\n  background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.5), transparent 55%);\r\n}\r\n\r\n.cu-ctaGlow--right {\r\n  background: radial-gradient(circle at 75% 30%, rgba(255, 255, 255, 0.35), transparent 60%);\r\n}\r\n\r\n.cu-ctaInner {\r\n  position: relative;\r\n  max-width: 960px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.cu-ctaInner h2 {\r\n  margin: 0;\r\n  font-size: clamp(2rem, 3vw, 2.6rem);\r\n  font-weight: 900;\r\n  color: #ffffff;\r\n}\r\n\r\n.cu-ctaInner p {\r\n  margin: 0.75rem 0 1.5rem;\r\n  max-width: 600px;\r\n  line-height: 1.6;\r\n  color: #ffffff;\r\n}\r\n\r\n.cu-ctaActions {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.cu-ctaPrimary,\r\n.cu-ctaGhost {\r\n  border-radius: 999px;\r\n  padding: 0.9rem 1.8rem;\r\n  font-weight: 700;\r\n  font-size: var(--cu-type-cta);\r\n  cursor: pointer;\r\n  border: none;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.cu-ctaPrimary {\r\n  background: #fff;\r\n  color: #370b3b;\r\n}\r\n\r\n.cu-ctaGhost {\r\n  background: transparent;\r\n  border: 1px solid rgba(255, 255, 255, 0.55);\r\n  color: #fff;\r\n  text-decoration: none;\r\n}\r\n\r\n.cu-ctaPrimary:hover,\r\n.cu-ctaGhost:hover {\r\n  transform: translateY(-2px);\r\n  color: #f59e0b;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .cu-main {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .cu-row2 {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .cu-spotlight,\r\n  .cu-ctaInner {\r\n    padding: 0 1rem;\r\n  }\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-page {\r\n  background: #02030a;\r\n  color: #f8fafc;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-hero__subtitle,\r\nhtml[data-theme=\"dark\"] .cu-formSub,\r\nhtml[data-theme=\"dark\"] .cu-centerInfo,\r\nhtml[data-theme=\"dark\"] .cu-ctaInner p {\r\n  color: rgba(248, 250, 252, 0.72);\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-quickCard,\r\nhtml[data-theme=\"dark\"] .cu-formCard,\r\nhtml[data-theme=\"dark\"] .cu-right,\r\nhtml[data-theme=\"dark\"] .cu-map,\r\nhtml[data-theme=\"dark\"] .cu-centerCard,\r\nhtml[data-theme=\"dark\"] .cu-cta {\r\n  background: #0b1220;\r\n  border-color: rgba(255, 255, 255, 0.1);\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.55);\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-mapOverlay,\r\nhtml[data-theme=\"dark\"] .cu-ctaGlow {\r\n  background: rgba(255, 255, 255, 0.05);\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-quickIcon {\r\n  background: rgba(255, 255, 255, 0.08);\r\n  color: #f8fafc;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-quickIcon--green {\r\n  background: rgba(22, 163, 74, 0.2);\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-input,\r\nhtml[data-theme=\"dark\"] .cu-textarea {\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border-color: rgba(255, 255, 255, 0.1);\r\n  color: #fff;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-mapBtn {\r\n  background: #1f66ff;\r\n  color: #fff;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-ctaPrimary {\r\n  background: #fff;\r\n  color: #0b1220;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-ctaGhost {\r\n  border-color: rgba(255, 255, 255, 0.24);\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-hero {\r\n  color: #f8fafc;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-quickSmall,\r\nhtml[data-theme=\"dark\"] .cu-quickBold,\r\nhtml[data-theme=\"dark\"] .cu-centerName,\r\nhtml[data-theme=\"dark\"] .cu-tag {\r\n  color: #f1f5ff;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-mapBg {\r\n  filter: none;\r\n  opacity: 0.7;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .cu-page::before {\r\n  content: \"\";\r\n  position: fixed;\r\n  inset: 0;\r\n  background: #02030a;\r\n  z-index: -1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
